// eslint-disable-next-line import/prefer-default-export
// @ts-ignore
export const color = (state) => state.color;
// @ts-ignore
export const active = (state) => state.active;
// @ts-ignore
export const message = (state) => state.message;
